


// kind of ok (use as ref) v4.4 fix header icon from chatgpt -> ref this version, it does look cleaner but its not as good as the original
// import React, { useState } from 'react';
// import { Filter } from '../';
// import Login from '../LoginClass';
// import { useNavigate } from 'react-router-dom';
// import './Header.css'; // Make sure Header.css includes relevant styles

// export const Header = ({ filterIsVisible, toggleFilter, handleFilterChange, clearFilter }) => {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const navigate = useNavigate();

//   const openModal = () => setIsModalOpen(true);
//   const closeModal = () => setIsModalOpen(false);

//   const handleHomeClick = () => navigate('/homepage');
//   const handleSearchClick = () => navigate('/explore');
//   const handleAddClick = () => navigate('/add');
//   const handleFavoritesClick = () => navigate('/favorites');
//   const handleProfileClick = () => openModal();

//   return (
//     <header className={`app-header ${filterIsVisible ? 'filter-is-visible' : ''}`}>
//       <Filter
//         toggleFilter={toggleFilter}
//         handleFilterChange={handleFilterChange}
//         clearFilter={clearFilter}
//       />
//       <nav className="header-nav">
//         <ul className="nav-list">
//           {/* Home */}
//           <li className="nav-item">
//             <button className="nav-button" onClick={handleHomeClick} aria-label="Home">
//               <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <path d="M3 9L12 2l9 7v11a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4h-2v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
//               </svg>
//             </button>
//           </li>

//           {/* Search */}
//           <li className="nav-item">
//             <button className="nav-button" onClick={handleSearchClick} aria-label="Search">
//               <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <circle cx="11" cy="11" r="8" />
//                 <line x1="21" y1="21" x2="16.65" y2="16.65" />
//               </svg>
//             </button>
//           </li>

//           {/* Add */}
//           <li className="nav-item center-icon">
//             <button className="nav-button" onClick={handleAddClick} aria-label="Add">
//               <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
//                 <line x1="12" y1="5" x2="12" y2="19" />
//                 <line x1="5" y1="12" x2="19" y2="12" />
//               </svg>
//             </button>
//           </li>

//           {/* Favorites */}
//           <li className="nav-item">
//             <button className="nav-button" onClick={handleFavoritesClick} aria-label="Favorites">
//               <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 1 0-7.8 7.8l1 1L12 21.3l7.8-7.8 1-1a5.5 5.5 0 0 0 0-7.8z" />
//               </svg>
//             </button>
//           </li>

//           {/* User Profile */}
//           <li className="nav-item">
//             <button className="nav-button active" onClick={handleProfileClick} aria-label="User">
//               <svg className="nav-icon" viewBox="0 0 24 24" fill="black">
//                 <circle cx="12" cy="8" r="4" />
//                 <path d="M4 20c0-4 4-6 8-6s8 2 8 6" />
//               </svg>
//             </button>
//           </li>
//         </ul>
//       </nav>
//       <Login isModalOpen={isModalOpen} closeModal={closeModal} />
//     </header>
//   );
// };

// export default Header;





// v4.3 currently ok
import React, { useState } from 'react';
import { Filter } from '../';
import Login from '../LoginClass';
import { useNavigate, useLocation } from 'react-router-dom';
import './Header.css'; // Import the CSS file for styling

export const Header = ({ filterIsVisible, toggleFilter, handleFilterChange, clearFilter }) => {
  const location = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleCrosshairClick = () => {
    navigate('/marker');
  };

  const handleCompassClick = () => {
    navigate('/');
  };

  const handleHomeClick = () => {
    navigate('/homepage');
  };

  const handlePage1Click = () => {
    navigate('/page1');
  };

  const handlePage2Click = () => {
    navigate('/page2');
  };

  const handlePage3Click = () => {
    navigate('/page3');
  };

  return (
    <header className={`app-header ${filterIsVisible ? 'filter-is-visible' : ''}`}>
      <Filter
        toggleFilter={toggleFilter}
        handleFilterChange={handleFilterChange}
        clearFilter={clearFilter}
      />
      <nav className="header-nav">
        <ul className="nav-list">
          <li className="nav-item">
            <button className={`nav-button ${location.pathname === '/homepage' ? 'active' : ''}`} onClick={handleHomeClick} aria-label="Home">
              <svg className="nav-icon" viewBox="0 0 26 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <title>Home</title>
                <path d="M2 10L13 2l11 8v11a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-5h-6v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z" />
              </svg>
            </button>
          </li>
          <li className="nav-item">
            <button className={`nav-button ${location.pathname === '/' ? 'active' : ''}`} onClick={handleCompassClick} aria-label="Explore">
              <svg className="nav-icon" fill="currentColor" height="24" role="img" viewBox="0 0 24 24" width="24">
                <title>Explore</title>
                <polygon fill="none" points="13.941 13.953 7.581 16.424 10.06 10.056 16.42 7.585 13.941 13.953" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></polygon>
                <polygon fillRule="evenodd" points="10.06 10.056 13.949 13.945 7.581 16.424 10.06 10.056"></polygon>
                <circle cx="12.001" cy="12.005" fill="none" r="10.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></circle>
              </svg>
            </button>
          </li>

          <li className="nav-item">
            <button
              className={`nav-button ${location.pathname === '/marker' ? 'active' : ''}`}
              onClick={handleCrosshairClick}
              aria-label="Target Crosshair"
            >
              <svg
                viewBox="0 0 20 24"
                width="60"
                height="60"
                fill="none"
                stroke={location.pathname === '/marker' ? 'black' : '#999'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="nav-icon"
                role="img"
                style={{
                  cursor: 'pointer',
                  display: 'block',
                  margin: '0 auto',
                  marginTop: '-4px' // nudge upward slightly
                }}
              >
                <title>Target Crosshair</title>
                <g transform="translate(0, 2)">
                  <rect x="3" y="3" width="18" height="18" rx="2" />
                  <path d="M12 8v8M8 12h8" />
                </g>
              </svg>
            </button>
          </li>

          <li className="nav-item">
            <button className={`nav-button ${location.pathname === '/user' ? 'active' : ''}`} onClick={openModal} aria-label="User">
              <svg className="nav-icon" fill="currentColor" height="24" role="img" viewBox="0 0 24 24" width="24">
                <title>User</title>
                <path d="M12 2a6 6 0 1 1-6 6 6 6 0 0 1 6-6Zm0 12c-4.29 0-8 2.24-8 5v2h16v-2c0-2.76-3.71-5-8-5Z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
              </svg>
            </button>
          </li>










        </ul>
      </nav>
      <Login isModalOpen={isModalOpen} closeModal={closeModal} />
    </header>
  );
};

export default Header;







// ok v4.2 fix 4.1
// import React, { useState } from 'react';
// import image from '../../images/house-location-pin.svg';
// import { Filter } from '../';
// import { Link } from 'react-router-dom';
// import Login from '../LoginClass';  // Import Login Modal
// import { useNavigate } from 'react-router-dom';

// export const Header = ({ filterIsVisible, toggleFilter, handleFilterChange, clearFilter }) => {
//   const [isModalOpen, setIsModalOpen] = useState(false);  // Manage modal state locally
//   const navigate = useNavigate();  // Hook for redirecting to other pages


//   // Open and close modal functions
//   const openModal = () => setIsModalOpen(true);
//   const closeModal = () => setIsModalOpen(false);

//   const handleCrosshairClick = () => {
//     navigate('/current');  // Redirect to /current
//   };


//   return (
//     <header className={`${filterIsVisible ? 'filter-is-visible' : ''}`}>
//       <Filter
//         toggleFilter={toggleFilter}
//         handleFilterChange={handleFilterChange}
//         clearFilter={clearFilter}
//       />

//       {/* <img src={image} alt="Property Listings" /> */}
//       <h1> </h1>

//       {/* Custom SVG Button for Home */}
//       <div className="x9f619 xjbqb8w x78zum5 x168nmei x13lgxp2 x5pf9jr xo71vjh x1n2onr6 x1plvlek xryxfnj x1c4vz4f x2lah0s xdt5ytf xqjyukv x1qjc9v5 x1oa3qoh x1nhvcw1">
//         <div className="x9f619 xxk0z11 xii2z7h x11xpdln x19c4wfv xvy4d1p" onClick={(e) => toggleFilter(e)}>
//           <svg
//             aria-label="Home"
//             className="x1lliihq x1n2onr6 x5n08af"
//             fill="currentColor"
//             height="24"
//             role="img"
//             viewBox="0 0 24 24"
//             width="24"
//           >
//             <title>Home</title>
//             <path d="M22 23h-6.001a1 1 0 0 1-1-1v-5.455a2.997 2.997 0 1 0-5.993 0V22a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V11.543a1.002 1.002 0 0 1 .31-.724l10-9.543a1.001 1.001 0 0 1 1.38 0l10 9.543a1.002 1.002 0 0 1 .31.724V22a1 1 0 0 1-1 1Z"></path>
//           </svg>
//         </div>
//       </div>

//       {/* Custom SVG Button for Explore */}
//       <div className="x9f619 xjbqb8w x78zum5 x168nmei x13lgxp2 x5pf9jr xo71vjh x1n2onr6 x1plvlek xryxfnj x1c4vz4f x2lah0s xdt5ytf xqjyukv x1qjc9v5 x1oa3qoh x1nhvcw1">
//         <div className="x9f619 xxk0z11 xii2z7h x11xpdln x19c4wfv xvy4d1p" onClick={(e) => toggleFilter(e)}>
//           <svg
//             aria-label="Explore"
//             className="x1lliihq x1n2onr6 x5n08af"
//             fill="currentColor"
//             height="24"
//             role="img"
//             viewBox="0 0 24 24"
//             width="24"
//           >
//             <title>Explore</title>
//             <polygon
//               fill="none"
//               points="13.941 13.953 7.581 16.424 10.06 10.056 16.42 7.585 13.941 13.953"
//               stroke="currentColor"
//               stroke-linecap="round"
//               stroke-linejoin="round"
//               stroke-width="2"
//             ></polygon>
//             <polygon
//               fill-rule="evenodd"
//               points="10.06 10.056 13.949 13.945 7.581 16.424 10.06 10.056"
//             ></polygon>
//             <circle
//               cx="12.001"
//               cy="12.005"
//               fill="none"
//               r="10.5"
//               stroke="currentColor"
//               stroke-linecap="round"
//               stroke-linejoin="round"
//               stroke-width="2"
//             ></circle>
//           </svg>
//         </div>
//       </div>

//       {/* Custom SVG Button for Search */}
//       <div className="x9f619 xjbqb8w x78zum5 x168nmei x13lgxp2 x5pf9jr xo71vjh x1n2onr6 x1plvlek xryxfnj x1c4vz4f x2lah0s xdt5ytf xqjyukv x1qjc9v5 x1oa3qoh x1nhvcw1">
//         <div className="x9f619 xxk0z11 xii2z7h x11xpdln x19c4wfv xvy4d1p" onClick={(e) => toggleFilter(e)}>
//           <svg
//             aria-label="Search"
//             className="x1lliihq x1n2onr6 x5n08af"
//             fill="currentColor"
//             height="24"
//             role="img"
//             viewBox="0 0 24 24"
//             width="24"
//           >
//             <title>Search</title>
//             <path
//               d="M19 10.5A8.5 8.5 0 1 1 10.5 2a8.5 8.5 0 0 1 8.5 8.5Z"
//               fill="none"
//               stroke="currentColor"
//               stroke-linecap="round"
//               stroke-linejoin="round"
//               stroke-width="2"
//             ></path>
//             <line
//               fill="none"
//               stroke="currentColor"
//               stroke-linecap="round"
//               stroke-linejoin="round"
//               stroke-width="2"
//               x1="16.511"
//               x2="22"
//               y1="16.511"
//               y2="22"
//             ></line>
//           </svg>
//         </div>
//       </div>

//       {/* Custom Human Icon Button */}
//       <div className="x9f619 xjbqb8w x78zum5 x168nmei x13lgxp2 x5pf9jr xo71vjh x1n2onr6 x1plvlek xryxfnj x1c4vz4f x2lah0s xdt5ytf xqjyukv x1qjc9v5 x1oa3qoh x1nhvcw1">
//         <div className="x9f619 xxk0z11 xii2z7h x11xpdln x19c4wfv xvy4d1p" onClick={(e) => openModal()}>
//           <svg
//             aria-label="User"
//             className="x1lliihq x1n2onr6 x5n08af"
//             fill="currentColor"
//             height="24"
//             role="img"
//             viewBox="0 0 24 24"
//             width="24"
//           >
//             <title>User</title>
//             <path
//               d="M12 2a6 6 0 1 1-6 6 6 6 0 0 1 6-6Zm0 12c-4.29 0-8 2.24-8 5v2h16v-2c0-2.76-3.71-5-8-5Z"
//               fill="none"
//               stroke="currentColor"
//               stroke-linecap="round"
//               stroke-linejoin="round"
//               stroke-width="2"
//             ></path>
//           </svg>
//         </div>
//       </div>

//       {/* Crosshair Icon with an empty center (more minimal) */}
//       <div className="x9f619 xjbqb8w x78zum5 x168nmei x13lgxp2 x5pf9jr xo71vjh x1n2onr6 x1plvlek xryxfnj x1c4vz4f x2lah0s xdt5ytf xqjyukv x1qjc9v5 x1oa3qoh x1nhvcw1">
//         <div
//           className="x9f619 xxk0z11 xii2z7h x11xpdln x19c4wfv xvy4d1p"
//           onClick={handleCrosshairClick}  // Handle the click event, e.g., redirect to '/current'
//         >
//           <svg
//             aria-label="Target Crosshair"
//             className="x1lliihq x1n2onr6 x5n08af"
//             fill="none"
//             height="24"
//             role="img"
//             viewBox="0 0 24 24"
//             width="24"
//           >
//             <title>Target Crosshair</title>
//             {/* Solid Circle at the center */}
//             <circle cx="12" cy="12" r="3" fill="black" />
//             {/* Larger Outer Circle */}
//             <circle cx="12" cy="12" r="8" stroke="black" strokeWidth="2" fill="none" />
//             {/* Rectangular Protrusions (Top, Right, Bottom, Left) */}
//             <rect x="11" y="1" width="2" height="3" fill="black" />
//             <rect x="11" y="20" width="2" height="3" fill="black" />
//             <rect x="1" y="11" width="3" height="2" fill="black" />
//             <rect x="20" y="11" width="3" height="2" fill="black" />
//           </svg>
//         </div>
//       </div>


//       {/* Render Login Modal */}
//       <Login isModalOpen={isModalOpen} closeModal={closeModal} />
//     </header>
//   );
// };

// export default Header;






// failed  v4.1 click on icon to navigate
// import React, { useState } from 'react';
// import image from '../../images/house-location-pin.svg';
// import { Filter } from '../';
// import { useNavigate } from 'react-router-dom';  // useNavigate for redirection
// import Login from '../LoginClass';  // Import Login Modal

// export const Header = ({ filterIsVisible, toggleFilter, handleFilterChange, clearFilter }) => {
//   const [isModalOpen, setIsModalOpen] = useState(false);  // Manage modal state locally
//   const navigate = useNavigate();  // Hook for redirecting to other pages

//   // Open and close modal functions
//   const openModal = () => setIsModalOpen(true);
//   const closeModal = () => setIsModalOpen(false);

//   // Function to handle crosshair redirection
//   const handleCrosshairClick = () => {
//     navigate('/current');  // Redirect to /current
//   };

//   return (
//     <header className={`${filterIsVisible ? 'filter-is-visible' : ''}`}>
//       <Filter
//         toggleFilter={toggleFilter}
//         handleFilterChange={handleFilterChange}
//         clearFilter={clearFilter}
//       />

//       {/* <img src={image} alt="Property Listings" /> */}
//       <h1> </h1>

//       {/* Custom SVG Button for Home */}
//       <div className="x9f619 xjbqb8w x78zum5 x168nmei x13lgxp2 x5pf9jr xo71vjh x1n2onr6 x1plvlek xryxfnj x1c4vz4f x2lah0s xdt5ytf xqjyukv x1qjc9v5 x1oa3qoh x1nhvcw1">
//         <div className="x9f619 xxk0z11 xii2z7h x11xpdln x19c4wfv xvy4d1p" onClick={(e) => toggleFilter(e)}>
//           <svg
//             aria-label="Home"
//             className="x1lliihq x1n2onr6 x5n08af"
//             fill="currentColor"
//             height="24"
//             role="img"
//             viewBox="0 0 24 24"
//             width="24"
//           >
//             <title>Home</title>
//             <path d="M22 23h-6.001a1 1 0 0 1-1-1v-5.455a2.997 2.997 0 1 0-5.993 0V22a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V11.543a1.002 1.002 0 0 1 .31-.724l10-9.543a1.001 1.001 0 0 1 1.38 0l10 9.543a1.002 1.002 0 0 1 .31.724V22a1 1 0 0 1-1 1Z"></path>
//           </svg>
//         </div>
//       </div>

//       {/* Custom SVG Button for Explore */}
//       <div className="x9f619 xjbqb8w x78zum5 x168nmei x13lgxp2 x5pf9jr xo71vjh x1n2onr6 x1plvlek xryxfnj x1c4vz4f x2lah0s xdt5ytf xqjyukv x1qjc9v5 x1oa3qoh x1nhvcw1">
//         <div className="x9f619 xxk0z11 xii2z7h x11xpdln x19c4wfv xvy4d1p" onClick={(e) => toggleFilter(e)}>
//           <svg
//             aria-label="Explore"
//             className="x1lliihq x1n2onr6 x5n08af"
//             fill="currentColor"
//             height="24"
//             role="img"
//             viewBox="0 0 24 24"
//             width="24"
//           >
//             <title>Explore</title>
//             <polygon
//               fill="none"
//               points="13.941 13.953 7.581 16.424 10.06 10.056 16.42 7.585 13.941 13.953"
//               stroke="currentColor"
//               stroke-linecap="round"
//               stroke-linejoin="round"
//               stroke-width="2"
//             ></polygon>
//             <polygon
//               fill-rule="evenodd"
//               points="10.06 10.056 13.949 13.945 7.581 16.424 10.06 10.056"
//             ></polygon>
//             <circle
//               cx="12.001"
//               cy="12.005"
//               fill="none"
//               r="10.5"
//               stroke="currentColor"
//               stroke-linecap="round"
//               stroke-linejoin="round"
//               stroke-width="2"
//             ></circle>
//           </svg>
//         </div>
//       </div>

//       {/* Custom SVG Button for Search */}
//       <div className="x9f619 xjbqb8w x78zum5 x168nmei x13lgxp2 x5pf9jr xo71vjh x1n2onr6 x1plvlek xryxfnj x1c4vz4f x2lah0s xdt5ytf xqjyukv x1qjc9v5 x1oa3qoh x1nhvcw1">
//         <div className="x9f619 xxk0z11 xii2z7h x11xpdln x19c4wfv xvy4d1p" onClick={(e) => toggleFilter(e)}>
//           <svg
//             aria-label="Search"
//             className="x1lliihq x1n2onr6 x5n08af"
//             fill="currentColor"
//             height="24"
//             role="img"
//             viewBox="0 0 24 24"
//             width="24"
//           >
//             <title>Search</title>
//             <path
//               d="M19 10.5A8.5 8.5 0 1 1 10.5 2a8.5 8.5 0 0 1 8.5 8.5Z"
//               fill="none"
//               stroke="currentColor"
//               stroke-linecap="round"
//               stroke-linejoin="round"
//               stroke-width="2"
//             ></path>
//             <line
//               fill="none"
//               stroke="currentColor"
//               stroke-linecap="round"
//               stroke-linejoin="round"
//               stroke-width="2"
//               x1="16.511"
//               x2="22"
//               y1="16.511"
//               y2="22"
//             ></line>
//           </svg>
//         </div>
//       </div>

//       {/* Crosshair Icon with an empty center (more minimal) */}
//       <div className="x9f619 xjbqb8w x78zum5 x168nmei x13lgxp2 x5pf9jr xo71vjh x1n2onr6 x1plvlek xryxfnj x1c4vz4f x2lah0s xdt5ytf xqjyukv x1qjc9v5 x1oa3qoh x1nhvcw1">
//         <div
//           className="x9f619 xxk0z11 xii2z7h x11xpdln x19c4wfv xvy4d1p"
//           onClick={handleCrosshairClick}  // Handle the click event, e.g., redirect to '/current'
//         >
//           <svg
//             aria-label="Target Crosshair"
//             className="x1lliihq x1n2onr6 x5n08af"
//             fill="none"
//             height="24"
//             role="img"
//             viewBox="0 0 24 24"
//             width="24"
//           >
//             <title>Target Crosshair</title>
//             {/* Solid Circle at the center */}
//             <circle cx="12" cy="12" r="3" fill="black" />
//             {/* Larger Outer Circle */}
//             <circle cx="12" cy="12" r="8" stroke="black" strokeWidth="2" fill="none" />
//             {/* Rectangular Protrusions (Top, Right, Bottom, Left) */}
//             <rect x="11" y="1" width="2" height="3" fill="black" />
//             <rect x="11" y="20" width="2" height="3" fill="black" />
//             <rect x="1" y="11" width="3" height="2" fill="black" />
//             <rect x="20" y="11" width="3" height="2" fill="black" />
//           </svg>
//         </div>
//       </div>

//       {/* Custom Human Icon Button */}
//       <div className="x9f619 xjbqb8w x78zum5 x168nmei x13lgxp2 x5pf9jr xo71vjh x1n2onr6 x1plvlek xryxfnj x1c4vz4f x2lah0s xdt5ytf xqjyukv x1qjc9v5 x1oa3qoh x1nhvcw1">
//         <div className="x9f619 xxk0z11 xii2z7h x11xpdln x19c4wfv xvy4d1p" onClick={openModal}>
//           <svg
//             aria-label="User"
//             className="x1lliihq x1n2onr6 x5n08af"
//             fill="currentColor"
//             height="24"
//             role="img"
//             viewBox="0 0 24 24"
//             width="24"
//           >
//             <title>User</title>
//             <path
//               d="M12 2a6 6 0 1 1-6 6 6 6 0 0 1 6-6Zm0 12c-4.29 0-8 2.24-8 5v2h16v-2c0-2.76-3.71-5-8-5Z"
//               fill="none"
//               stroke="currentColor"
//               stroke-linecap="round"
//               stroke-linejoin="round"
//               stroke-width="2"
//             ></path>
//           </svg>
//         </div>
//       </div>

//       {/* Modal for Login */}
//       {isModalOpen && <Login closeModal={closeModal} />}
//     </header>
//   );
// };

// export default Header;




// ok v4 add the icon from insta
// import React, { useState } from 'react';
// import image from '../../images/house-location-pin.svg';
// import { Filter } from '../';
// import { Link } from 'react-router-dom';
// import Login from '../LoginClass';  // Import Login Modal

// export const Header = ({ filterIsVisible, toggleFilter, handleFilterChange, clearFilter }) => {
//   const [isModalOpen, setIsModalOpen] = useState(false);  // Manage modal state locally

//   // Open and close modal functions
//   const openModal = () => setIsModalOpen(true);
//   const closeModal = () => setIsModalOpen(false);

//   return (
//     <header className={`${filterIsVisible ? 'filter-is-visible' : ''}`}>
//       <Filter
//         toggleFilter={toggleFilter}
//         handleFilterChange={handleFilterChange}
//         clearFilter={clearFilter}
//       />

//       {/* <img src={image} alt="Property Listings" /> */}
//       <h1> </h1>

//       {/* Custom SVG Button for Home */}
//       <div className="x9f619 xjbqb8w x78zum5 x168nmei x13lgxp2 x5pf9jr xo71vjh x1n2onr6 x1plvlek xryxfnj x1c4vz4f x2lah0s xdt5ytf xqjyukv x1qjc9v5 x1oa3qoh x1nhvcw1">
//         <div className="x9f619 xxk0z11 xii2z7h x11xpdln x19c4wfv xvy4d1p" onClick={(e) => toggleFilter(e)}>
//           <svg
//             aria-label="Home"
//             className="x1lliihq x1n2onr6 x5n08af"
//             fill="currentColor"
//             height="24"
//             role="img"
//             viewBox="0 0 24 24"
//             width="24"
//           >
//             <title>Home</title>
//             <path d="M22 23h-6.001a1 1 0 0 1-1-1v-5.455a2.997 2.997 0 1 0-5.993 0V22a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V11.543a1.002 1.002 0 0 1 .31-.724l10-9.543a1.001 1.001 0 0 1 1.38 0l10 9.543a1.002 1.002 0 0 1 .31.724V22a1 1 0 0 1-1 1Z"></path>
//           </svg>
//         </div>
//       </div>

//       {/* Custom SVG Button for Explore */}
//       <div className="x9f619 xjbqb8w x78zum5 x168nmei x13lgxp2 x5pf9jr xo71vjh x1n2onr6 x1plvlek xryxfnj x1c4vz4f x2lah0s xdt5ytf xqjyukv x1qjc9v5 x1oa3qoh x1nhvcw1">
//         <div className="x9f619 xxk0z11 xii2z7h x11xpdln x19c4wfv xvy4d1p" onClick={(e) => toggleFilter(e)}>
//           <svg
//             aria-label="Explore"
//             className="x1lliihq x1n2onr6 x5n08af"
//             fill="currentColor"
//             height="24"
//             role="img"
//             viewBox="0 0 24 24"
//             width="24"
//           >
//             <title>Explore</title>
//             <polygon
//               fill="none"
//               points="13.941 13.953 7.581 16.424 10.06 10.056 16.42 7.585 13.941 13.953"
//               stroke="currentColor"
//               stroke-linecap="round"
//               stroke-linejoin="round"
//               stroke-width="2"
//             ></polygon>
//             <polygon
//               fill-rule="evenodd"
//               points="10.06 10.056 13.949 13.945 7.581 16.424 10.06 10.056"
//             ></polygon>
//             <circle
//               cx="12.001"
//               cy="12.005"
//               fill="none"
//               r="10.5"
//               stroke="currentColor"
//               stroke-linecap="round"
//               stroke-linejoin="round"
//               stroke-width="2"
//             ></circle>
//           </svg>
//         </div>
//       </div>

//       {/* Custom SVG Button for Search */}
//       <div className="x9f619 xjbqb8w x78zum5 x168nmei x13lgxp2 x5pf9jr xo71vjh x1n2onr6 x1plvlek xryxfnj x1c4vz4f x2lah0s xdt5ytf xqjyukv x1qjc9v5 x1oa3qoh x1nhvcw1">
//         <div className="x9f619 xxk0z11 xii2z7h x11xpdln x19c4wfv xvy4d1p" onClick={(e) => toggleFilter(e)}>
//           <svg
//             aria-label="Search"
//             className="x1lliihq x1n2onr6 x5n08af"
//             fill="currentColor"
//             height="24"
//             role="img"
//             viewBox="0 0 24 24"
//             width="24"
//           >
//             <title>Search</title>
//             <path
//               d="M19 10.5A8.5 8.5 0 1 1 10.5 2a8.5 8.5 0 0 1 8.5 8.5Z"
//               fill="none"
//               stroke="currentColor"
//               stroke-linecap="round"
//               stroke-linejoin="round"
//               stroke-width="2"
//             ></path>
//             <line
//               fill="none"
//               stroke="currentColor"
//               stroke-linecap="round"
//               stroke-linejoin="round"
//               stroke-width="2"
//               x1="16.511"
//               x2="22"
//               y1="16.511"
//               y2="22"
//             ></line>
//           </svg>
//         </div>
//       </div>

//       {/* Custom Human Icon Button */}
//       <div className="x9f619 xjbqb8w x78zum5 x168nmei x13lgxp2 x5pf9jr xo71vjh x1n2onr6 x1plvlek xryxfnj x1c4vz4f x2lah0s xdt5ytf xqjyukv x1qjc9v5 x1oa3qoh x1nhvcw1">
//         <div className="x9f619 xxk0z11 xii2z7h x11xpdln x19c4wfv xvy4d1p" onClick={(e) => openModal()}>
//           <svg
//             aria-label="User"
//             className="x1lliihq x1n2onr6 x5n08af"
//             fill="currentColor"
//             height="24"
//             role="img"
//             viewBox="0 0 24 24"
//             width="24"
//           >
//             <title>User</title>
//             <path
//               d="M12 2a6 6 0 1 1-6 6 6 6 0 0 1 6-6Zm0 12c-4.29 0-8 2.24-8 5v2h16v-2c0-2.76-3.71-5-8-5Z"
//               fill="none"
//               stroke="currentColor"
//               stroke-linecap="round"
//               stroke-linejoin="round"
//               stroke-width="2"
//             ></path>
//           </svg>
//         </div>
//       </div>

//       <Link to="/current">
//         <button className="btn-current">Current</button>
//       </Link>

//       {/* Trigger the modal */}
//       <button className="btn-login" onClick={openModal}>
//         Login
//       </button>

//       {/* Render Login Modal */}
//       <Login isModalOpen={isModalOpen} closeModal={closeModal} />
//     </header>
//   );
// };

// export default Header;








// ok v3.1 revert back to non bootstrap
// import React, { useState } from 'react';
// import image from '../../images/house-location-pin.svg';
// import { Filter } from '../';
// import { Link } from 'react-router-dom';
// import Login from '../LoginClass';  // Import Login Modal

// export const Header = ({ filterIsVisible, toggleFilter, handleFilterChange, clearFilter }) => {
//   const [isModalOpen, setIsModalOpen] = useState(false);  // Manage modal state locally

//   // Open and close modal functions
//   const openModal = () => setIsModalOpen(true);
//   const closeModal = () => setIsModalOpen(false);

//   return (
//     <header className={`${filterIsVisible ? 'filter-is-visible' : ''}`}>
//       <Filter
//         toggleFilter={toggleFilter}
//         handleFilterChange={handleFilterChange}
//         clearFilter={clearFilter}
//       />

//       <img src={image} alt="Property Listings" />
//       <h1> </h1>

//       <button className="btn-filter" onClick={(e) => toggleFilter(e)}>
//         Filter
//       </button>

//       <Link to="/current">
//         <button className="btn-current">Current</button>
//       </Link>

//       {/* Trigger the modal */}
//       <button className="btn-login" onClick={openModal}>
//         Login
//       </button>

//       {/* Render Login Modal */}
//       <Login isModalOpen={isModalOpen} closeModal={closeModal} />
//     </header>
//   );
// };

// export default Header;


// failed ?? v3 make the header nicer, ref airbnb
// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import Login from '../LoginClass';  // Import Login Modal
// import './Header.css';  // Keep this import path
// import 'bootstrap/dist/css/bootstrap.min.css';  // Import Bootstrap styles

// export const Header = ({ filterIsVisible, toggleFilter, handleFilterChange, clearFilter }) => {
//   const [isModalOpen, setIsModalOpen] = useState(false);  // Manage modal state locally

//   // Open and close modal functions
//   const openModal = () => setIsModalOpen(true);
//   const closeModal = () => setIsModalOpen(false);

//   return (
//     <header className="header container-fluid p-0">
//       <div className="row w-100 m-0 align-items-center">
//         <div className="col-6 col-md-4 p-0">
//           {/* Logo container */}
//           <div className="logo-container">
//             {/* Optional: Add logo image here */}
//             {/* <h1>Airbnb</h1> */}
//           </div>
//         </div>

//         <div className="col-6 col-md-8 d-flex justify-content-end align-items-center p-0">
//           {/* Filter Button */}
//           <button className="btn btn-outline-secondary d-flex align-items-center ms-1" onClick={(e) => toggleFilter(e)}>
//             <div className="icon filter"></div>
//             <span className="btn-text ms-2">Filter</span>
//           </button>

//           {/* Current Button with Crosshair Icon */}
//           <Link to="/current" className="btn btn-outline-secondary d-flex align-items-center ms-1">
//             <div className="icon crosshair"></div>
//             <span className="btn-text ms-2">Current</span>
//           </Link>

//           {/* Login Button with User Icon */}
//           <button className="btn btn-outline-secondary d-flex align-items-center ms-1" onClick={openModal}>
//             <div className="icon user"></div>
//             <span className="btn-text ms-2">Login</span>
//           </button>
//         </div>
//       </div>

//       {/* Render Login Modal */}
//       <Login isModalOpen={isModalOpen} closeModal={closeModal} />
//     </header>
//   );
// };

// export default Header;





// ok v2 add modal
// import React, { useState } from 'react';
// import image from '../../images/house-location-pin.svg';
// import { Filter } from '../';
// import { Link } from 'react-router-dom';
// import Login from '../LoginClass';  // Import Login Modal

// export const Header = ({ filterIsVisible, toggleFilter, handleFilterChange, clearFilter }) => {
//   const [isModalOpen, setIsModalOpen] = useState(false);  // Manage modal state locally

//   // Open and close modal functions
//   const openModal = () => setIsModalOpen(true);
//   const closeModal = () => setIsModalOpen(false);

//   return (
//     <header className={`${filterIsVisible ? 'filter-is-visible' : ''}`}>
//       <Filter
//         toggleFilter={toggleFilter}
//         handleFilterChange={handleFilterChange}
//         clearFilter={clearFilter}
//       />

//       <img src={image} alt="Property Listings" />
//       <h1> </h1>

//       <button className="btn-filter" onClick={(e) => toggleFilter(e)}>
//         Filter
//       </button>

//       <Link to="/current">
//         <button className="btn-current">Current</button>
//       </Link>

//       {/* Trigger the modal */}
//       <button className="btn-login" onClick={openModal}>
//         Login
//       </button>

//       {/* Render Login Modal */}
//       <Login isModalOpen={isModalOpen} closeModal={closeModal} />
//     </header>
//   );
// };

// export default Header;





// ok v1
// import React from 'react';
// import image from '../../images/house-location-pin.svg';
// import { Filter } from '../';
// import { Link } from 'react-router-dom';
// import Login from '../LoginClass';

// export const Header = ({filterIsVisible, toggleFilter, handleFilterChange, clearFilter}) => {
//     return (
//         <header className={`${filterIsVisible ? 'filter-is-visible': ''}`}>
//           <Filter
//             toggleFilter={toggleFilter}
//             handleFilterChange={handleFilterChange}
//             clearFilter={clearFilter}
//           />

//           <img src={image} alt="Property Listings" />
//           <h1> </h1>
//           <button className="btn-filter" onClick={(e) => toggleFilter(e)}>Filter</button>

//           <Link to="/current">
//             <button className="btn-current">Current</button>
//           </Link>
//           {/* <Link to="/login">
//             <button className="btn-current">Login</button>
//           </Link> */}
//           {/* <button type="submit">Login</button> */}
//           <Login/>


//         </header>
//     )
// }

// export default Header;
